import { mapState, mapMutations } from 'vuex'
import debounce from 'lodash.debounce'
import FiltersSelect from '@/components/filters-select/filters-select.vue'
import FiltersSearch from '@/components/filters-search/filters-search.vue'
import IcClearThin from '@/assets/svg/ic-clear-thin.svg?inline'
import { getDefaultFilters } from '@/store/orders'

export default {
  name: 'Filters',
  components: {
    FiltersSelect,
    FiltersSearch,
    IcClearThin
  },
  computed: {
    ...mapState({
      storeFilters: state => state.orders.filters,
      courierOptions: state => state.couriers.couriers,
      paymentOptions: state => {
        const paymentTypes = state.sharedData.paymentTypes
        return Object.keys(paymentTypes).map((key, index) => ({
          id: index + 1,
          title: paymentTypes[key].title,
          value: key
        }))
      }
    }),
    rtOptions() {
      return [
        { id: 1, title: 'Авто', value: true },
        { id: 2, title: 'Ручное', value: false },
      ]
    },
    showClearFilters() {
      let result = false
      const filtersKeys = Object.keys(this.storeFilters)
        /**
         * кнопка работает кроме поиска,
         * статусы в панели внизу обрабатываются
         */
        .filter(key => ['search', 'statuses'].indexOf(key) === -1)
      for (let i = 0; i < filtersKeys.length; i++) {
        const filterVal = this.storeFilters[filtersKeys[i]]
        const testVal = Array.isArray(filterVal) ? filterVal.length : filterVal
        if (testVal) {
          result = true
          break
        }
      }
      return result
    }
  },
  methods: {
    ...mapMutations({
      setFilters: 'orders/SET_FILTERS'
    }),
    getCourierOptionName(courier) {
      if (courier) {
        return `${courier.last_name} ${courier.first_name}`
      }
      return ''
    },
    onInputFilters(key, event) {
      this.setFilters({
        ...this.storeFilters,
        [key]: event
      })
    },
    onSearchInput: debounce(function (event) {
      this.onInputFilters('search', event)
    }, '300ms'),

    clearFilters() {
      const filtersDefault = getDefaultFilters()
      /**
       * кнопка работает кроме поиска
       */
      delete filtersDefault.search
      /**
       * статусы обрабатываются в панели
       */
      delete filtersDefault.statuses
      this.setFilters({
        ...this.storeFilters,
        ...filtersDefault
      })
    }
  }
}
